import React, { useContext, useState } from 'react';
import Button from 'antd/lib/button';
import { BuyContext } from './Workflow';
import { ModelContext } from './metadata/ModelSource';
import { navigateWithData } from '../navigation/navigationHistory';
import {ConfigContext} from 'portal-core/components/PortalApp';
import {formatMoneyAmount} from '../utils/formatUtils';
import {EstimatedQuoteText} from '../../../app/config/HtmlFormatedText'
import {ApplicationActionsContext} from "./data/ApplicationDataSource";


export const EstimatedQuote = ({ title, disableButton }) => {
  const { isValid } = useContext(BuyContext);
  const [isLoading, setIsLoading] = useState(false);
  const applicationModel = useContext(ModelContext);
  const config = useContext(ConfigContext);
  const { saveApplication } = useContext(ApplicationActionsContext);
  const applicationAdvanceText = config.branding.buttons.applicationAdvance ? config.branding.buttons.quoteAdvance : 'Apply Now';

  const total =
      parseFloat(applicationModel.data.basicPolicy.writtenPremiumAmt) +
      parseFloat(applicationModel.data.basicPolicy.writtenFeeAmt);

  const totalAmt = isNaN(total) ? '$0.00' : formatMoneyAmount(total);

  return (
      <div className="estimated-prem" style={styles.container}>
        <h2 id='estimated-prem-title' style={styles.title}>
          {title ? title.toUpperCase() : 'ESTIMATED PREMIUM'}
        </h2>
        <h3 style={styles.amountText}>
          <span style={{ fontWeight: 800 }}>{totalAmt}</span>/{applicationModel.data.basicPolicy.renewalTermCd}
        </h3>
        <EstimatedQuoteText productVersionIdRef={applicationModel.data.basicPolicy.productVersionIdRef}/>
        { !disableButton &&
          <Button
              type="primary"
              onClick={() => {
                setIsLoading(true);
                saveApplication().then(()=>{
                  navigateWithData('/consumer-consent', {
                    model: applicationModel.data,
                    actionData: {
                      execute: 'convertToQuote',
                      arguments: [applicationModel.data.systemId, applicationModel.data.typeCd, 0, [0, 0]],
                    },
                  }).then(()=>{
                    setIsLoading(false);
                  });
                })
              }}
              loading={isLoading}
              disabled={!isValid}
          >
            {applicationAdvanceText}
          </Button>
        }
      </div>
  );
};

const styles = {
  amountText: {
    fontSize: '26px',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    margin: 'auto',
    marginBottom: '30px',
  },
  title: {
    fontSize: '18px',
  },
};